/**
 * Returns basic device information including browser, OS, platform, and IP address
 * @returns {Object} Device information object
 */
const getDeviceInfo = () =>
{
	// Browser detection
	const getUserAgent = () =>
	{
		const userAgent = navigator.userAgent;

		if (userAgent.includes('Chrome') && !userAgent.includes('Edg'))
		{
			return 'Chrome';
		}
		else if (userAgent.includes('Firefox'))
		{
			return 'Firefox';
		}
		else if (userAgent.includes('Safari') && !userAgent.includes('Chrome'))
		{
			return 'Safari';
		}
		else if (userAgent.includes('Edg'))
		{
			return 'Edge';
		}
		else if (userAgent.includes('Opera') || userAgent.includes('OPR'))
		{
			return 'Opera';
		}
		else
		{
			return 'Unknown';
		}
	};

	// OS detection
	const getOperatingSystem = () =>
	{
		const userAgent = navigator.userAgent;
		const platform = navigator.platform;

		if (userAgent.includes('Windows'))
		{
			return 'Windows';
		}
		else if (userAgent.includes('Mac'))
		{
			return 'macOS';
		}
		else if (userAgent.includes('Linux'))
		{
			return 'Linux';
		}
		else if (userAgent.includes('Android'))
		{
			return 'Android';
		}
		else if (userAgent.includes('iOS'))
		{
			return 'iOS';
		}
		else
		{
			return 'Unknown';
		}
	};

	// Platform detection
	const getPlatform = () =>
	{
		const userAgent = navigator.userAgent;

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent))
		{
			return 'mobile';
		}
		else if (/iPad|Android/i.test(userAgent))
		{
			return 'tablet';
		}
		else
		{
			return 'desktop';
		}
	};

	// Screen information
	const getScreenInfo = () =>
	{
		return {
			width       : screen.width,
			height      : screen.height,
			availWidth  : screen.availWidth,
			availHeight : screen.availHeight,
			colorDepth  : screen.colorDepth,
			pixelDepth  : screen.pixelDepth
		};
	};

	// Language and locale
	const getLanguageInfo = () =>
	{
		return {
			language     : navigator.language,
			languages    : navigator.languages,
			userLanguage : navigator.userLanguage || navigator.language
		};
	};

	// Connection information
	const getConnectionInfo = () =>
	{
		if ('connection' in navigator)
		{
			const connection = navigator.connection;

			return {
				effectiveType : connection.effectiveType || 'unknown',
				downlink      : connection.downlink || 0,
				rtt           : connection.rtt || 0,
				saveData      : connection.saveData || false
			};
		}

		return {
			effectiveType : 'unknown',
			downlink      : 0,
			rtt           : 0,
			saveData      : false
		};
	};

	// Return comprehensive device information
	return {
		browser   : getUserAgent(),
		os        : getOperatingSystem(),
		platform  : getPlatform(),
		// screen     : getScreenInfo(),
		// language   : getLanguageInfo(),
		// connection : getConnectionInfo(),
		userAgent : navigator.userAgent,
		timestamp : new Date().toISOString()
	};
};

// Export the function
export default getDeviceInfo;
